import React from "react";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";

import summaryProgress from "../../images/summary_progress.svg";
import { waveformOffsetClass } from "./transcript.styles";

/**
 * Component shown during LOADING state when restarting RTMS for transcription
 * Subject to change in the future
 */
const TranscribeRestarting = () => {
  return (
    <Column alignmentHorizontal="start" width="100%" spacing="400" spacingInset="none">
      <img src={summaryProgress} alt="" className={waveformOffsetClass} />
      <Text type="h50" alignment="start">
        Restarting - up to 1 min
      </Text>
    </Column>
  );
};

export default TranscribeRestarting;
